"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePoolRemainingTime = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var react_1 = require("react");
var useSaleTimeline_1 = require("../../pool/hooks/useSaleTimeline");
var utils_1 = require("../../shared/utils");
var defaultLabels = {
    untilRegistration: "Registration opens in",
    untilRegistrationClose: "Registration closes in",
    untilStart: "Sale opens in",
    untilFcfs: "FCFS opens in",
    untilClose: "Closes in",
    finished: "Finished",
};
function usePoolRemainingTime(labels, formatDiffTime) {
    if (labels === void 0) { labels = defaultLabels; }
    var _a = (0, useSaleTimeline_1.useSaleTimeline)(), start = _a.start, end = _a.end, registerStart = _a.registerStart, registerEnd = _a.registerEnd, fcfsStart = _a.fcfsStart;
    var _b = (0, react_1.useState)(function () { return (0, dayjs_1.default)(); }), now = _b[0], setNow = _b[1];
    var formatTime = formatDiffTime || utils_1.getTimeDiffString;
    (0, react_1.useEffect)(function () {
        if (!start)
            return;
        var id = setInterval(function () { return setNow((0, dayjs_1.default)()); }, 1000);
        return function () { return clearInterval(id); };
    }, [start]);
    if (!start) {
        return {
            time: "TBA",
            label: "Start",
        };
    }
    var untilRegister = registerStart && (0, utils_1.getTimeDiff)(now, registerStart);
    var untilRegisterEnd = registerEnd && (0, utils_1.getTimeDiff)(now, registerEnd);
    var untilStart = (0, utils_1.getTimeDiff)(now, start);
    var untilEnd = end && (0, utils_1.getTimeDiff)(now, end);
    var untilFCFS = fcfsStart && (0, utils_1.getTimeDiff)(now, fcfsStart);
    var sinceEnd = (0, utils_1.getTimeDiff)(end, now);
    if ((untilRegister === null || untilRegister === void 0 ? void 0 : untilRegister.asSeconds()) > 0) {
        return {
            time: formatTime(untilRegister, { smallerIfBig: true }),
            label: labels === null || labels === void 0 ? void 0 : labels.untilRegistration,
        };
    }
    if ((untilRegisterEnd === null || untilRegisterEnd === void 0 ? void 0 : untilRegisterEnd.asSeconds()) > 0) {
        return {
            time: formatTime(untilRegisterEnd, { smallerIfBig: true }),
            label: labels === null || labels === void 0 ? void 0 : labels.untilRegistrationClose,
        };
    }
    if (untilStart.asSeconds() > 0) {
        return {
            time: formatTime(untilStart, { smallerIfBig: true }),
            label: labels === null || labels === void 0 ? void 0 : labels.untilStart,
        };
    }
    if ((untilEnd === null || untilEnd === void 0 ? void 0 : untilEnd.asSeconds()) > 0) {
        if ((untilFCFS === null || untilFCFS === void 0 ? void 0 : untilFCFS.asSeconds()) > 0) {
            return {
                time: formatTime(untilFCFS, { smallerIfBig: true }),
                label: labels === null || labels === void 0 ? void 0 : labels.untilFcfs,
            };
        }
        return {
            time: formatTime(untilEnd, { smallerIfBig: true }),
            label: labels === null || labels === void 0 ? void 0 : labels.untilClose,
        };
    }
    return {
        time: formatTime(sinceEnd, {
            minutes: true,
            seconds: true,
        }),
        label: labels === null || labels === void 0 ? void 0 : labels.finished,
    };
}
exports.usePoolRemainingTime = usePoolRemainingTime;
